import React, { useState, useEffect } from 'react';
import AppDataTable from '../../components/AppDataTable';
import { fetchCategories, addBookCategory, updateBookCategory } from '../../apiCalls';
export default function BookCategory() {

    const [categories, setCategories] = useState([]);
    const [name, setName] = useState("");
    const [editingId, setEditingId] = useState(null);

    //////////////////////////////////////////////////////
    // Fetch Categories
    const getCategoriesData = async () => {
        try {
            const res = await fetchCategories();
            setCategories(res || []);
        } catch (error) {
            console.error("Failed to load categories", error);
        }
    };

    useEffect(() => {
        getCategoriesData();
    }, []);

    //////////////////////////////////////////////////////
    // Add / Update Category
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim()) return;

        try {
            if (editingId) {
                // Update
                const res = await updateBookCategory(editingId, { name });

                if (res?.status) {
                    setCategories(prev =>
                        prev.map(cat =>
                            cat.category_id === editingId
                                ? { ...cat, name }
                                : cat
                        )
                    );
                    setEditingId(null);
                }

            } else {
                // Add
                const res = await addBookCategory({ name });

                if (res?.status) {
                    fetchCategories();
                }
            }

            setName("");

        } catch (error) {
            console.log(error);
        }
    };

    //////////////////////////////////////////////////////
    // Edit
    const handleEdit = (row) => {
        setName(row.name);
        setEditingId(row.category_id);
    };

    //////////////////////////////////////////////////////
    // Table Columns
    const columns = [
        {
            name: "Category Name",
            selector: row => row.name,
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <i
                    className="bi bi-pencil-square text-warning fs-5"
                    style={{ cursor: "pointer" }}
                    title="Edit Category"
                    onClick={() => handleEdit(row)}
                ></i>
            ),
        }
    ];

    //////////////////////////////////////////////////////
    return (
        <>
            <div className='page-title-container'>
                <h2>
                    Manage Book Category
                    <span>
                        List of all book categories | Add, View, Edit the books categories
                    </span>
                </h2>
            </div>
            <div className='page-title-container pt-2'>

                {/* Add / Edit Form */}
                <form
                    className="d-flex align-items-center gap-3 my-3"
                    onSubmit={handleSubmit}
                >
                    <input
                        type="text"
                        className="form-control w-50"
                        placeholder="Enter Category Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />

                    <button
                        type="submit"
                        className="save-btn btn btn-dark btn-sm"
                    >
                        {editingId ? "Update Category" : "Add Category"}
                    </button>

                    {editingId && (
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm save-btn"
                            onClick={() => {
                                setEditingId(null);
                                setName("");
                            }}
                        >
                            Cancel
                        </button>
                    )}
                </form>
            </div>

            {/* Table */}
            <AppDataTable
                columns={columns}
                data={categories}
            />
        </>
    );
}